<template>
  <div class="news">
    <div class="news-wrap">
      <div class="news-list-item-wrap" :class="{'border-right': newsTrendsList.length < newsList.length}">
        <div  class="news-list-item" :class="{'border-0': index=== newsList.length-1}" @click="goArtcle(v)" v-for="(v,index) in newsList" :key="index">
          <div class="news-list-item-img">
            <img class="bg-img" :src="v.imgUrl || '/a'"  @error="imgError('/img/newimg.png')">
          </div>
          <div class="news-list-item-text">
            <div class="title txt-line-3" style="word-break:break-all">{{v.title}}</div>
            <div class="subTitle txt-line-3">{{v.described}}</div>
          </div>
        </div>
      </div>
      <div class="news-list-trends" :class="{'border-left': newsTrendsList.length > newsList.length}">
         <h2 class="list-title" style="font-weight:500">精选动态</h2>
         <div class="new-trends-item border-bottom" :class="{'border-bottom': i!==newsTrendsList.length-1}" v-for="(v, i) in newsTrendsList" :key="i" @click="goArtcle(v)">
          <div class="title news-list-trends-title txt-line-2">{{v.title}}</div>
          <div style="margin-bottom: 10px;" class="described txt-line-2">{{v.described}}</div>
         </div>
      </div>
    </div>
    <div class="project-pagination-wrap hidden-xs-only">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          :page-size="pageSize"
          :pager-count="5"
          layout="total, prev, pager, next"
          :total="total">
        </el-pagination>
    </div>
    <div class="news-mobile-wrap">
      <div class="news-list-item-wrap">
        <div class="news-list-item" @click="goArtcle(v)" :class="{'border-bottom': index!==newsList.length-1}" v-for="(v,index) in newsList" :key="index">
          <div class="news-list-item-img">
            <img class="bg-img" :src="v.imgUrl || '/a'"  @error="imgError('/img/newimg.png')">
          </div>
          <div class="news-list-item-text">
            <div class="title txt-line-2">{{v.title}}</div>
            <div class="flex">
              <div style="width:50%;" class="subTitle txt-line-2">{{v.described}}</div>
              <div class="detail">了解详情></div>
            </div>
          </div>
        </div>
      </div>
      <div class="project-pagination-wrap hide-pc">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          :page-size="pageSize"
          :pager-count="5"
          layout="total, prev, pager, next"
          :total="total">
        </el-pagination>
      </div>
      <h2 class="list-title border-bottom">精选动态</h2>
      <div class="news-list-trends">
         
         <div class="new-trends-item" :class="{'margin-0': (i+1)%2 === 0}" v-for="(v, i) in newsTrendsList" :key="i" @click="goArtcle(v)">
            <div class="news-list-item-img">
              <img class="bg-img" :src="v.imgUrl || '/a'"  @error="imgError('/img/newimg.png')">
            </div>
            <div class="title txt-line-2 txt-line-2">{{v.title}}</div>
         </div>
      </div>
    </div>
  </div>
</template>
<script>
import {getEliteArticleList} from '@/api/news'
import {getColumns} from '@/api/home'
import {getArticleListByColId} from '@/api/project'
import {imgError} from '@/assets/utility.js'
export default {
    name: "news",
    //components: { NewsList },
    data() {
        return {
            newsTrendsList: [],
            colId: '',
            currentPage: 1,
            pageSize: 3,
            newsList: [],
            total: 0,
        }
    },
    mounted() {
      this.$store.commit('setNewsTabI', 0)
        getEliteArticleList().then(res => {
            if (res) {
                this.newsTrendsList = res
            }
        })
        if (this.$route.query.colId) {
          this.colId = this.$route.query.colId
          this.loadList()
          //this.$refs.newslist.loadData(this.colId)
        } else {
          getColumns(this.$route.params.cid).then(res => {
            if (res) {
                if (res[0].subList.length > 0) {
                    this.colId = res[0].subList[0].colId
                    this.loadList()
                    //this.$refs.newslist.loadData(this.colId)
                }
            }
          })
        }
    },
    methods: {
        imgError(pUrl) {
            imgError(pUrl)
        },
         goArtcle(pData) {
             this.$router.push(`/article/${pData.id}`)
        },
        loadList () {
           getArticleListByColId(this.colId, this.currentPage, this.pageSize).then(res => {
              if (res) {
                this.newsList = res.rows
                this.total = Number(res.total)
              }
            })
        },
        handleCurrentChange (e) {
            this.currentPage = e
            this.loadList()
        }
    }
}
</script>
<style lang="scss" scoped>
  .news {
    margin-top: 30px;
  }
  .border-bottom {
      border-bottom: 1px solid #bfbfbf;
  }
  @media only screen and (min-width: 768px) {
    .news-mobile-wrap {
      display: none;
    }
    .news-wrap {
      margin-bottom: rem(10);
      .border-0 {
        border-bottom: none;
      }
    }
    .border-right {
      border-right: 1px solid #bfbfbf;
    }
    .border-left {
      border-left: 1px solid #bfbfbf;
    }
    .list-title {
      padding-bottom: rem(30);
    }
    .news-list-trends-title {
      word-break:break-all;
      min-height: 60px;
    }
    .hide-pc {
      display:none;
    }
  }
  @media only screen and (max-width: 768px) {
    .news-mobile-wrap {
      display: block;
      padding: 0 rem(75);
      
      .list-title {
          font-size: .4rem;
          padding-bottom: .3rem;
      }
      .news-list-trends { 
        display: flex;
        justify-content: space-between;
        flex-wrap:wrap;
        .new-trends-item {
          width: 3.1rem;
          margin:0 .3rem .5rem 0;
          .news-list-item-img {
            margin-bottom: .3rem;
          }
          .title {
            color:#999999;
            font-size: .27rem;
          }
        }
        .margin-0 {
          margin-right: 0;
        }
      }
    }
    .news-wrap {
      display: none;
    }
    .hide-pc {
      display:block;
    }
  }
</style>